import Text from 'components/Text/Text';
import React from 'react';
import classNames from 'classnames';
import { DnDList } from './components/DnDList/DnDList';
import style from './ChangePositionList.module.scss';

export const ChangePositionList: React.FC = () => {
	const subCategoryHeadingClasses = classNames(style.subCategory, style.heading);
	const hiddenStatusHeadingClasses = classNames(style.hiddenStatus, style.heading);
	const availableForRepetitionHeadingClasses = classNames(style.availableForRepetition, style.heading);

	return (
		<div className={style.container} data-test="ChangePositionList">
			<div className={style.tableHeaders}>
				<Text
					className={subCategoryHeadingClasses}
					translationNameSpace="listing"
					translationKey="subcategoryLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={hiddenStatusHeadingClasses}
					translationNameSpace="listing"
					translationKey="hiddenStatusLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={availableForRepetitionHeadingClasses}
					translationNameSpace="listing"
					translationKey="availableForRepetitionLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
			</div>
			<DnDList />
		</div>
	);
};
